<template>
  <v-container>
    <h2>Update address</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="address.firstname"
              label="Firstname"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="address.lastname"
              label="Lastname"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="address.company_name"
              label="Company name"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="address.company_branch"
              label="Company branch"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="address.tax_id"
              label="Tax ID"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-textarea
              v-model="address.address_detail"
              label="Address detail"
              outlined
              dense
              height="80"
            ></v-textarea>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="address.address_sub_district"
              label="Sub-district"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="address.address_district"
              label="District"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="address.address_country"
              label="Country"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="address.address_postal_code"
              label="Postal code/zipcode"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="address.phone_number"
              label="Phone number"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateAddress"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'address-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "AddressEdit",
  components: { },
  data: () => ({
    address_id: null,
    address: {
      firstname: null,
      lastname: null,
      company_name: null,
      company_branch: null,
      tax_id: null,
      address_detail: null,
      address_sub_district: null,
      address_district: null,
      address_province: null,
      address_country: null,
      address_postal_code: null,
      phone_number: null,
      customer_id: null
    },
    rules: {
      require: value => !!value || 'Please fill in information',
      personal_id: value => !value || value.length < 14 || 'Tax ID must have 13 digits',
    },
  }),
  async mounted () {
    let id = this.$route.params.id
    await this.getAddress(id)
  },
  methods: {
    async updateAddress () {
      try {
        await this.$http.put(`/back-office/addresses/${this.address_id}`, this.address, authHeader())
        this.$router.push({ name: 'address-list'})
      } catch (err) {
        if (err.response)
          console.log(err.response.data)
        else
          console.log(err)
        alert('Something went wrong')
      }
    },
    async getAddress (id) {
      this.address_id = id
      try {
        const { data } = await this.$http.get(`/back-office/addresses/${this.address_id}`, authHeader())
        this.address.firstname = data.firstname
        this.address.lastname = data.lastname
        this.address.company_name = data.company_name
        this.address.company_branch = data.company_branch
        this.address.tax_id = data.tax_id
        this.address.address_detail = data.address_detail
        this.address.address_sub_district = data.address_sub_district
        this.address.address_district = data.address_district
        this.address.address_province = data.address_province
        this.address.address_country = data.address_country
        this.address.address_postal_code = data.address_postal_code
        this.address.customer_id = data.customer_id
      } catch (err) {
        if (err.response)
          console.log(err.repsonse)
        else
          console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.address.firstname) {
        alert('Please fill in firstname')
        return false;
      }
      return true
    }
  },
};
</script>
